// Generate newsletters from #1 to #43
const generateJobsNewsletters = () => {
    const newsletters = [];
    for (let i = 43; i >= 1; i--) {
        newsletters.push({
            title: `#${i} Jobs Newsletter`,
            imageSrc: "/jobImage.png",
            articleLink: `https://womenineconpolicy.substack.com/p/${i}-jobs-newsletter`
        });
    }
    return newsletters;
};

const newsData = {
    "jobs": generateJobsNewsletters(),
    "archive": [
        {
            title: 'Budgets: Through a Gender Lens',
            imageSrc: '/archive1.png',
            articleLink: 'https://womenineconpolicy.substack.com/p/budgets-through-a-gender-lens?s=r&utm_campaign=post&utm_medium=web'
        },
        {
            title: 'Gender and the Digital Divide',
            imageSrc: '/archive2.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=594bb7757a'
        },
        {
            title: 'Gender and the Digital Divide',
            imageSrc: '/archive3.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=4292222b7d'
        },
        {
            title: 'Pre-Doctoral and Research Assistant Positions',
            imageSrc: '/archive4.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=0c0e1b3460'
        },
        {
            title: 'Inclusive Cities',
            imageSrc: '/archive5.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=4432511385'
        },
        {
            title: 'Pride and Prejudice: Inclusion in the fields of Econ and Policy',
            imageSrc: '/archive6.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=8bcbf017c0'
        },
        {
            title: 'Women in Politics',
            imageSrc: '/archive7.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=5c72d4a6e7'
        },
        {
            title: 'Jobs in the development & Policy Sector',
            imageSrc: '/archive8.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=794421f919'
        },
        {
            title: 'Gender differences in time use',
            imageSrc: '/archive9.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=6b913a29c0'
        },
        {
            title: 'Female Entrepreneurship',
            imageSrc: '/archive10.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=5340595c02'
        },
        {
            title: 'The gig economy and women',
            imageSrc: '/archive11.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=4d3ac93a23'
        },
        {
            title: 'Identity and Social Exclusion',
            imageSrc: '/archive12.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=b929cc20fe'
        },
        {
            title: 'Letter from the Editors desk',
            imageSrc: '/archive13.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=b7dfcf4b8a'
        },
        {
            title: 'Women and Climate Change',
            imageSrc: '/archive14.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=7b984706da'
        },
        {
            title: 'Feminist Economics',
            imageSrc: '/archive15.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=ffa03945c5'
        },
        {
            title: 'Intra-household decision making',
            imageSrc: '/archive16.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=e3fc3906c5'
        },
        {
            title: 'Financial Inclusion and Women',
            imageSrc: '/archive17.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=e4313afa6b'
        },
        {
            title: 'Agriculture and Women',
            imageSrc: '/archive18.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=9a9693dfe9'
        },
        {
            title: 'Stories from the field',
            imageSrc: '/archive19.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=a32d494ab4'
        },
        {
            title: 'Intimate Partner Violence (IPV) and Women',
            imageSrc: '/archive20.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=e4313afa6b'
        },
        {
            title: 'COVID 19 and Women',
            imageSrc: '/archive21.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=9e03ccbecb'
        },
        {
            title: 'Development through a gender lens',
            imageSrc: '/archive22.png',
            articleLink: 'https://us17.campaign-archive.com/?u=3d315482a01ddd29e7b7161ac&id=d80e12d1be'
        },

    ]
}

export default newsData
